
class GiftQuantity extends QuantityInput {
  constructor() {
    super();
  }

  init() {
    super.init();

    this.giftWrapping = document.querySelector('gift-wrapping');
    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart'));

    // 真实商品数量 = 总商品数 - 赠品数
    this.realItemsInCart = this.cartItemsSize - this.giftWrapsInCart;

    // 只要有真实商品，就固定赠品数量为 1，否则 0
    this.itemsInCart = this.realItemsInCart > 0 ? 1 : 0;

    // 如果没真实商品但赠品还在 → 移除
    if (this.realItemsInCart <= 0 && this.giftWrapsInCart > 0) {
      this.giftWrapping.removeGiftWrap();
    }
    // 如果有真实商品但赠品数量不对 → 修正
    else if (this.realItemsInCart > 0 && this.giftWrapsInCart != 1) {
      this.update();
    }
  }

  update() {
    this.input.value = this.itemsInCart; // 始终 0 或 1
    this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('gift-quantity', GiftQuantity);


class GiftWrapping extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');
    this.giftWrapId = this.dataset.giftWrapId;
    this.giftWrapping = this.dataset.giftWrapping;
    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart'));

    // 真实商品数量 = 总商品数 - 赠品数
    this.realItemsInCart = this.cartItemsSize - this.giftWrapsInCart;

    // 只要有真实商品，就固定赠品数量为 1，否则 0
    this.itemsInCart = this.realItemsInCart > 0 ? 1 : 0;

    const checkbox = this.querySelector('[name="attributes[gift-wrapping]"]');
    checkbox.addEventListener("change", (event) => {
      event.target.checked ? this.setGiftWrap() : this.removeGiftWrap();
    });

    // 默认勾选逻辑：如果没设置过 gift-wrapping 且有商品，就勾上
    if (!this.giftWrapping && this.realItemsInCart > 0) {
      checkbox.checked = true;
      this.setGiftWrap();
    }

    if (this.miniCart) return;

    // 如果没有真实商品但赠品还在 → 移除
    if (this.realItemsInCart <= 0 && this.giftWrapsInCart > 0) {
      this.removeGiftWrap();
    }
    // 如果有真实商品但赠品没加 → 添加
    else if (this.realItemsInCart > 0 && this.giftWrapsInCart == 0) {
      this.setGiftWrap();
    }
    // 如果有真实商品但赠品数量不对 → 修正
    else if (this.realItemsInCart > 0 && this.giftWrapsInCart != 1) {
      this.setGiftWrap();
    }
  }

  setGiftWrap() {
    const loadingOverlay = this.querySelector('.loading-overlay');
    loadingOverlay.classList.remove('hidden');

    const sections = this.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: 1   // 始终固定 1
      },
      attributes: {
        'gift-wrapping': true
      },
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        loadingOverlay.classList.add('hidden');

        if (document.body.classList.contains('template-cart')) {
          window.location.href = theme.routes.cart_url;
          return;
        }

        this.miniCart && this.miniCart.renderContents(response);
      })
      .catch((e) => console.error(e));
  }

  removeGiftWrap() {
    const loadingOverlay = this.querySelector('.loading-overlay');
    loadingOverlay.classList.remove('hidden');

    const sections = this.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: 0
      },
      attributes: {
        'gift-wrapping': '',
        'gift-note': ''
      },
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        loadingOverlay.classList.add('hidden');

        if (document.body.classList.contains('template-cart')) {
          window.location.href = theme.routes.cart_url;
          return;
        }

        this.miniCart && this.miniCart.renderContents(response);
      })
      .catch((e) => console.error(e));
  }

  getSectionsToRender() {
    return [
      { id: 'mini-cart', section: 'mini-cart', selector: '.shopify-section' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'mobile-cart-icon-bubble', section: 'mobile-cart-icon-bubble', selector: '.shopify-section' },
      { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' }
    ];
  }
}
customElements.define('gift-wrapping', GiftWrapping);


class GiftNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ attributes: { 'gift-note': event.target.value } });
      fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    }, 300));
  }
}
customElements.define('gift-note', GiftNote);
